<template>
  <div class="login-main">
    <!-- 登录框 -->
    <div class="login-content">
      <div class="login-sys">
        <div class="login-form-hd">
          <span class="sys-ico1 iconfont">&#xe637;</span>
          <span class="sys-ico2 iconfont">&#xe724;</span>
          <span class="sys-ico3 iconfont">&#xe60e;</span>
          <div class="sys-content flex">
            <div class="sys-hd">
              <div class="sys-logo"><img class="ico inline-block" src="../../assets/images/logo.jpg" /></div>
              <div class="sys-name">佛山市顺德区非居民用水累计加价系统</div>
            </div>
          </div>
          <div class="login-form flex">
              <div class="form-title">
                <h2 class="title">账户登录</h2>
                <p class="tips">您可以直接输入您的账号和密码登录，如遇到无法登陆，请联系 0757-22836993</p>
              </div>
              <div class="form-box">
                <div class="in-box">
                  <i class="ico inline-block el-icon-user"></i>
                  <span class="inp inline-block"><el-input class="nobor-input" v-model="account" placeholder="请输入账号" size="medium" @change="handleInputChange"></el-input></span>
                </div>
                <div class="in-box">
                  <i class="ico inline-block el-icon-lock"></i>
                  <span class="inp inline-block"><el-input class="nobor-input" v-model="password" placeholder="请输入密码" size="medium" show-password @change="handleInputChange"></el-input></span>
                </div>
                <div class="form-verify">
                  <span class="verify inline-block"><el-input class="nobor-input" v-model="verify" placeholder="验证码" size="medium" @change="handleInputChange"></el-input></span>
                  <img id="verifyimg" class="verifyimg inline-block" :src="verifyimg" alt="验证码"/>
                  <span class="verifytxt inline-block" @click="$loadverify">点击切换</span>
                </div>
                <div class="form-selcheck">
                  <el-checkbox v-model="remember">记住密码</el-checkbox>
                  <router-link class="flt" to="/skjs/resetPassword">忘记密码？</router-link>
                </div>
                <div class="form-submit">
                  <div class="btn-box" :class="{ 'disabled': disabled }" @click="login">登 录</div>
                </div>
                <p class="form-tips">{{msg}}</p>
              </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 登录框 -->
    <!-- 版权信息 -->
    <Copyright></Copyright>
    <!-- 版权信息 -->
    <!-- 特效 -->
    <div class="waveHorizontals mobile-hide"> 
      <div id="waveHorizontal1" class="waveHorizontal"></div>
      <div id="waveHorizontal2" class="waveHorizontal"></div>
      <div id="waveHorizontal3" class="waveHorizontal"></div>
    </div>
  </div>
</template>

<script>
import Copyright from '@/views/public/Copyright'
import {
  A_UA_Login,
  A_UA_SendVerify
} from '@/assets/js/axiosPresets'
export default {
  name: 'login',
  props: {},
  data () {
    return {
      account: '', // 账号
      password: '', // 密码
      verify: '', // 验证码
      verifyimg: '', // 验证码图片
      remember: false, // 是否记住密码
      msg: '', // 提示
      disabled: false // 登录按钮是否禁用
    }
  },
  components: {
    Copyright
  },
  mounted () {
    this.account = atob(window.HD.Cookie.Get('account')) || ''
    if (this.account && window.HD.Cookie.Get("password")) {
      try {
        this.password = atob(window.HD.Cookie.Get("password"))
      } catch (error) {}
      this.remember = true
    }
    this.$loadverify()
  },
  methods: {
    // 数据：获取验证码
    async $loadverify () {
      this.verifyimg = '/ashx/CodeTools.ashx?t=' + new Date().valueOf()
    },
    // 数据：获取手机验证码
    async $getPhoneVerify () {
      var R = await this.$F_checkAxios(A_UA_SendVerify({
        Mobiles: this.forgetForm.km_phone
      }))
      if (!R) {
        return
      }
      this.phoneVerify = true
      this.handleCountDown()
    },
    // 功能：登录
    async login () {
      if (this.disabled) {
        return false
      }
      if (!this.account) {
        this.msg = '请输入账号'
        this.disabled = false
      } else if (!this.password) {
        this.msg = '请输入密码'
        this.disabled = false
      } else if (!this.verify) {
        this.msg = '请输入验证码'
        this.disabled = false
      } else {
        this.disabled = true
        this.msg = '登录中...'
        const postData = {
          userName: this.account,
          passWord: btoa(this.password),
          validCode: this.verify
        }
        const R = await A_UA_Login(postData)
        try {
          // console.log(R)
          if (R.status !== 200) {
            return false
          }
          const RData = JSON.parse(R.data.d)
          if (!RData.Status) {
            this.msg = `${RData.Message}`
            this.$message({ type: 'error', message: RData.Message })
            this.$loadverify()
            this.disabled = false
            return false
          }
          
          this.msg = '登录成功，正在跳转...'
          this.$message({ type: 'success', message: this.msg })
          if (this.remember) {
            window.HD.Cookie.Set('account', btoa(this.account), 3)
            window.HD.Cookie.Set('password', btoa(this.password), 3)
          } else {
            window.HD.Cookie.Set('account', '', -1)
            window.HD.Cookie.Set('password', '', -1)
          }
          window.HD.Cookie.Set('token', RData.Token, 3)
          setTimeout(() => {
            this.$router.push('/skjs/main/homePage')
            this.disabled = false
          }, 100)
        } catch (error) {
          // console.log(error)
          this.msg = '程序异常'
          this.disabled = false
        }
      }
    },
    // 功能：监听输入框输入
    handleInputChange () {
      this.msg = ''
    },
    // 弹窗：关闭重置密码弹窗
    handleForgetPswDialogClose () {
      this.pswShow = false
      this.forgetForm = {
        km_phone: '',
        km_verify: ''
      }
    },
    // 功能：倒计时
    handleCountDown () {
      if (this.countDown === 1) {
        this.phoneVerify = false
        this.countDown = 60
        return false
      }
      this.countDown--
      setTimeout(() => {
        this.handleCountDown()
      }, 1000)
    }
  }
}
</script>

<style scoped lang="scss">
.login-main {
  position: relative;
  height: 100%;
  background: url('../../assets/images/login-bg.png') center/cover no-repeat;

  .inline-block {
    display: inline-block;
    vertical-align: middle;
  }

  .login-content {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -291px;
    margin-left: -576px;
    overflow: hidden;
    background-color: #fff;
    border-radius: 30px;
    width: 1152px;
    height: 582px;

    .flex {
      flex: 1;
    }

    .login-sys {
      padding: 20px;
      height: calc(100% - 40px);
    }

    .login-form-hd {
      position: relative;
      display: -webkit-flex;
      display: flex;
      flex-wrap: nowrap;
      height: 100%;

      .sys-ico1 {
        position: absolute;
        top: -25px;
        right: 0;
        font-size: 60px;
        color: #d8d3ae;
      }

      .sys-ico2 {
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 70px;
        color: #0da5d0;
      }

      .sys-ico3 {
        position: absolute;
        top: 0;
        left: 40%;
        font-size: 70px;
        color: #f1e5e6;
      }

      .sys-content {
        position: relative;
        height: 100%;

        .sys-hd {
          position: absolute;
          top: 100px;
          left: 50%;
          margin-left: -160px;
          padding: 40px;
          width: 320px;
          border-radius: 20px;
          box-shadow: 0 0 5px #ddd;

          .sys-logo {
            margin-bottom: 20px;
            text-align: center;

            .ico {
              width: 100px;
            }
          }

          .sys-name {
            text-align: center;
            font-size: 30px;
          }
        }
      }

      .login-img {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1.5;
        height: 100%;

        .img-pic {
          display: block;
          // width: 50%;
        }
      }

      .login-form {
        padding: 0 10%;
        height: 100%;

        .form-title {
          .title {
            margin-bottom: 5px;
            font-size: 23px;
          }

          .tips {
            color: #9e9e9e;
          }
        }

        .form-box {
          margin-top: 10%;

          .in-box {
            margin-bottom: 10px;
            padding: 10px 0;
            border-bottom: 1px dashed #ddd;

            .ico {
              margin-right: 10px;
              display: inline-block;
              vertical-align: middle;
              font-size: 20px;
              color: #9e9e9e;
            }

            .inp {
              width: calc(100% - 30px);
            }
          }

          .form-verify {
            margin: 20px 0 10px;

            .verify {
              margin-right: 15px;
              width: 150px;
              border: 1px dashed #ddd;
              border-radius: 3px;
            }

            .verifytxt {
              margin-left: 10px;
              cursor: pointer;

              &:hover {
                color: #129ac6;
              }
            }
          }

          .form-selcheck {
            overflow: hidden;
            padding: 10px 0;

            .flt {
              float: right;
              cursor: pointer;

              &:hover {
                color: #129ac6;
              }
            }
          }

          .form-submit {
            margin-top: 15%;

            .btn-box {
              margin: 0 5%;
              background: #0295f9;
              // background: -webkit-linear-gradient(left, #44c8cc, #e0a96f, #dcdc73);
              background: linear-gradient(-125deg,#0295f9 0%, #2f49fd 100%);
              line-height: 45px;
              cursor: pointer;
              border-radius: 20px 20px;
              text-align: center;
              color: #fff;
              font-size: 16px;

              &:hover {
                opacity: .8;
              }

              &.disabled {
                cursor: no-drop;
                background: #e5e5e5;
              }
            }
          }

          .form-tips {
            margin-top: 15px;
            text-align: center;
            cursor: default;
            color: #cc1e1e;
          }
          .form-error {
            margin-top: 6px;
            text-align: center;
            color: #666;
          }
        }
      }
    }
  }

  .waveHorizontals {
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: 1;
    width: 100%;
    height: 20px;

    .waveHorizontal {
      width: 200%;
      height: 100%;
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      background-repeat: repeat-x;
      background-position: left bottom;
      background-size: 350px 100%;
      transform-origin: 0 100% 0;
      animation-name: move;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }

    @keyframes move{0%{transform:translate(-175px,0px) scale(1,1)}50%{transform:translate(-87px,0px) scale(1,0.5)}100%{transform:translate(0px,0px) scale(1,1)}}

    #waveHorizontal1 {
      -webkit-mask: url('../../assets/images/wave/ripples1.svg');
      mask: url('../../assets/images/wave/ripples1.svg');
      animation-delay: -2s;
      animation-duration: 12s;
    }

    #waveHorizontal2 {
      -webkit-mask: url('../../assets/images/wave/ripples2.svg');
      mask: url('../../assets/images/wave/ripples2.svg');
      animation-delay: -2s;
      animation-duration: 5s;
    }

    #waveHorizontal3 {
      -webkit-mask: url('../../assets/images/wave/ripples3.svg');
      mask: url('../../assets/images/wave/ripples3.svg');
      animation-delay: -1s;
      animation-duration: 3s;
    }

    #waveHorizontal1, #waveHorizontal2, #waveHorizontal3 {
      background-image: linear-gradient(20deg,#18cef2 0,#448aff 100%)!important;
    }
  }

  .dialog-forget-psw {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;

    .madal {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .5);
    }

    .forget-madal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: -webkit-translate(-50%, -50%);
      transform: -moz-translate(-50%, -50%);
      transform: -o-translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 20px;
      border-radius: 10px;
      background-color: #fff;
      width: 500px;

      .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        color: #9e9e9e;
        cursor: pointer;
      }

      .title {
        margin-bottom: 25px;
        font-size: 16px;
        font-weight: 700;
      }

      .form-body {
        .verify {
          .in-box {
            margin-right: 15px;
            width: 140px;
          }

          .verify-btn {
            &:hover {
              cursor: pointer;
              color: #129ac6;
            }
          }

          .verify-tips {
            background-color: #e5e5e5;
            padding: 0 10px;
            border: 1px solid #ddd;
            font-size: 12px;
          }
        }
      }

      .forget-submit {
        margin-top: 70px;
        margin-bottom: 20px;

        .btn-box {
          margin: 0 30px;
          line-height: 40px;
          text-align: center;
          border-radius: 20px;
          color: #fff;
          font-size: 16px;
          background-color: #129ac6;
          cursor: pointer;

          &:hover {
            background-color: #67aec5;
          }
        }
      }
    }
  }
}
</style>
